import { useParams } from 'react-router';

function useClientIdPathParam() {
    const { clientId } = useParams();
    return clientId as string;
}

export default useClientIdPathParam;
